import { StaticImageData } from 'next/image';

export type BadgeSize = 'sm' | 'lg' | 'xl';

export type BadgeDef = {
  certName: string;
  certDescription: string;
  image: string | StaticImageData;
  size: BadgeSize;
};

// The badge strip header reads "certifications in progress": none of these are
// claimed as complete. Blueberries is pursuing SOC 2 Type II, not yet certified.
export const ICONS: Record<string, BadgeDef> = {
  SOC2: {
    certName: 'SOC 2 Type II (in progress)',
    certDescription: 'SOC 2 Type II certification in progress',
    image:
      'https://www.digitalforensics.com/images/jch-optimize/ng/images_certs_soc-2.webp',
    size: 'sm',
  },
  GDPR: {
    certName: 'GDPR',
    certDescription: 'GDPR',
    image: 'https://www.genesys.com/media/GDPR-e1672263252689.png',
    size: 'sm',
  },
  ISO27001: {
    certName: 'ISO 27001',
    certDescription: 'ISO 27001',
    image: '/assets/security/isoimg.png',
    size: 'lg',
  },
  CSA: {
    certName: 'CSA STAR Level 1',
    certDescription: 'CSA STAR Level 1',
    image: '/assets/security/star1img.png',
    size: 'sm',
  },
  SSO: {
    certName: 'SSO',
    certDescription: 'SSO',
    image: '/assets/security/sso.webp',
    size: 'xl',
  },
};
